import { render, staticRenderFns } from "./LegalProcess.vue?vue&type=template&id=a5c81450&"
import script from "./LegalProcess.vue?vue&type=script&lang=js&"
export * from "./LegalProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports